import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, Typography } from 'seagull';
import styles from './IntegrationCard.module.scss';
export default function IntegrationCard(props) {
    const { testId, icon, title, subTitle, mainAction, disclaimer } = props;
    return /*#__PURE__*/ _jsxs(Card, {
        testId: testId,
        className: styles.card,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12
                },
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: icon
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                weight: "normal",
                                children: title
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                testId: testId && "".concat(testId, "-sub-title"),
                                variant: 'paragraph2',
                                skin: "secondary",
                                children: subTitle
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.bottom,
                children: [
                    mainAction,
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: 'paragraph3',
                        skin: "secondary",
                        children: disclaimer || ' '
                    })
                ]
            })
        ]
    });
}
IntegrationCard.LogoImg = (_0)=>{
    let { padding } = _0, rest = _object_without_properties(_0, [
        "padding"
    ]);
    return /*#__PURE__*/ _jsx("img", _object_spread({
        style: {
            height: 40,
            padding
        }
    }, rest));
};
IntegrationCard.MainActionButton = (props)=>/*#__PURE__*/ _jsx(Button, _object_spread({
        size: "small"
    }, props));
